import React from "react";
import { Link } from "react-router-dom";
import "../assets/styles/_footer.scss";

export const Footer = () => {
  const menu = [
    {
      title: "選ばれる理由",
      href: "/lp",
    },
    {
      title: "コンサルタント紹介",
      href: "/consultant",
    },
    {
      title: "プライバシーポリシー",
      href: "/privacy",
    },
    {
      title: "会社概要",
      href: "/company",
    },
    {
      title: "コラム",
      href: "/column",
    },
    // {
    //   title: "採用情報",
    //   href: "",
    // },
    {
      title: "お知らせ",
      href: "/news",
    },
  ];
  return (
    <footer>
      <section className="main-menu">
        <div className="inner">
          <div className="company-title">
            <p>未来へ繋ぐ資産運用</p>
            <h2>ドリミット株式会社</h2>
          </div>
          <div className="contents">
            <div className="bnr">
              <Link to="/lp">
                <img src="../images/menu-bnr.png" alt="" />
              </Link>
            </div>
            <ul>
              {menu.map((item, index) => {
                return (
                  <li key={index}>
                    <Link to={item.href}>{item.title}</Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <p className="copy">&copy; 2022 ドリミット株式会社</p>
      </section>
    </footer>
  );
};
